/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_Macos_DescInputs */

const en_cad_download_macos_desc = /** @type {(inputs: Cad_Download_Macos_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universal DMG for Apple silicon and Intel Macs`)
};

/**
* | output |
* | --- |
* | "Universal DMG for Apple silicon and Intel Macs" |
*
* @param {Cad_Download_Macos_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_macos_desc = /** @type {((inputs?: Cad_Download_Macos_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_Macos_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_macos_desc(inputs)
});
export { cad_download_macos_desc as "cad.download.macos_desc" }